import React from "react";

import { Redirect } from "react-router-dom";
import { makeStyles } from "@material-ui/core";

import { FranchiseType, PropositionAllocation } from "@hubcapp/types";
import { NewLearner } from "@hubcapp/components";
import { useAuth } from "@hubcapp/context";
import { useQueryGetInstructorPropositionDetails } from "@hubcapp/hooks";

import Content from "@ds-developer/content";
import PageHeader from "@ds-developer/page-header";

const useStyles = makeStyles(theme => ({
  content: {
    marginTop: theme.spacing(2),

    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}));

const AddLearner = () => {
  const classes = useStyles();
  const {
    instructor: { id: instructorId },
  } = useAuth();

  const {
    data: instructorDetailsData,
    loading: instructorDetailsLoading,
  } = useQueryGetInstructorPropositionDetails(instructorId);

  const franchises = (
    instructorDetailsData?.instructor?.propositions || []
  ).filter(
    (propAl: PropositionAllocation) =>
      propAl.proposition?.type === FranchiseType.Full ||
      propAl.proposition?.type === FranchiseType.PartnerLite ||
      propAl.proposition?.type === FranchiseType.Trainee,
  );

  if (!instructorDetailsLoading && !(franchises && franchises.length)) {
    return <Redirect to="/learners" />;
  }

  return (
    <Content>
      <PageHeader
        breadcrumbs={[
          { link: "/", title: "Home" },
          { link: "/learners", title: "Learners" },
          { title: "Add learner" },
        ]}
        title={"Add a new learner"}
      />
      <div className={classes.content}>
        <NewLearner />
      </div>
    </Content>
  );
};

export default AddLearner;
